import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Avatar } from '@companycam/slab-web';

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: var(--cc_size_spacing_s);
`;

const OwnerName = styled.p`
  font-size: var(--cc_size_text_xs);
  margin: 0 0 0 var(--cc_size_spacing_s);
  color: var(--cc_color_text_nonessential);
  line-height: normal;
`;

const IconContainer = styled.div`
  color: var(--cc_color_text_nonessential);
  background-color: var(--cc_color_background_3);
  height: var(--cc_size_spacing_l);
  width: var(--cc_size_spacing_l);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
`;

const StyledIcon = styled.i`
  font-size: 16px;
  opacity: 0.75;
`;

const OwnerInfo = ({ owner }) => {
  const { logo, name } = owner;
  return (
    <InfoContainer>
      {logo ? (
        <Avatar
          fullName={name}
          alt={`${name} logo`}
          imageSrc={logo}
          size="small"
        />
      ) : (
        <IconContainer>
          <StyledIcon className="mdi mdi-office-building" />
        </IconContainer>
      )}
      <OwnerName>{name}</OwnerName>
    </InfoContainer>
  );
};

OwnerInfo.propTypes = {
  owner: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo: PropTypes.string,
  }).isRequired,
};

export default OwnerInfo;
